import { type TranslationFunction } from '@unisporkal/localization';

type AbstractedSize = {
  name?: string;
  label: string;
  teeShirtSize?: string;
};

const assetSizeLabel = (
  t: TranslationFunction,
  size: AbstractedSize
): string => {
  if (!size) {
    return '';
  }
  if (size.name === 'eps') {
    return 'EPS';
  }

  const label = size.label || size.teeShirtSize;
  const assetSizesLabelMapping: Record<string, string> = {
    XS: t('extrasmall'),
    S: t('small'),
    M: t('medium'),
    L: t('large'),
    XL: t('extra_large'),
  };

  if (!label) return '';
  return assetSizesLabelMapping[label] || label;
};

export default assetSizeLabel;
